import { ref } from 'vue'

const currentCategory = ref({ brandName: '', category: '' })
export function useCategoryService (options) {
  function setCurrentCategory (brandName, category) {
    currentCategory.value.brandName = brandName
    currentCategory.value.category = category
  }

  function categoryCouponImage () {
    return process.env.VUE_APP_ASSET_HOST + '/static/' + currentCategory.value.brandName + `/images/${currentCategory.value.brandName}_coupon_${currentCategory.value.category}.jpg`
  }

  return {
    setCurrentCategory,
    categoryCouponImage
  }
} // useCategoryService
